<template>
	<div class="row mx-3 my-5">
		<div class="col-12">
			<div class="card">
				<div class="card-body">
					<div class="card-title d-flex">
						<h4 class="mr-auto">Liste Ausschussware</h4>
					</div>

					<table class="table">
						<thead>
						<tr>
							<th>EAN</th>
							<th>Zustand</th>
							<th>Anzahl</th>
							<th>Ort</th>
							<th>Benutzer</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="item in temporaryDamagedGoodsItems" :key="item.id">
							<td>{{item.ean}}</td>
							<td>{{customItemNoteTemplateMap[item.customItemNoteTemplateId]}}</td>
							<td v-if="authorization.shipping_manager === true">
								<click-to-edit-component
										:value="String(item.quantity)"
										@input="item.quantity = $event"
										:data-id="item.id"
										data-path="/temporarydamagedgoods/quantity">
								</click-to-edit-component>
							</td>
							<td v-else>{{ item.quantity }}</td>
							<td>{{item.stockyard}}</td>
							<td>{{item.user}}</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
export default {
	name: "TemporaryDamagedGoodsTable",
	props: {
		userRole: {
			type: String,
			required: true
		},
		passedTemporaryDamagedGoodsItems: {
			type: Array,
			required: true
		},
		customItemNoteTemplateMap: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			authorization: {},
			temporaryDamagedGoodsItems: [],
		};
	},
	methods: {
	},
	created() {
		axios.get("/user/authorization")
		.then((auth) => {
			this.authorization = auth.data;
		});
	},
	mounted() {
		this.temporaryDamagedGoodsItems = this.passedTemporaryDamagedGoodsItems;
	},
}
</script>


<style scoped>

</style>